import type { Routes } from '@angular/router';
import { secureRoute } from './core/utils/transformers';
import { IcdCodeCreateComponent } from './features/codes/pages/icd-code-create/icd-code-create';
import { IcdCodeDetailsComponent } from './features/codes/pages/icd-code-details/icd-code-details';
import { IcdCodeEditComponent } from './features/codes/pages/icd-code-edit/icd-code-edit';
import { Icd10CodeEditComponent } from './features/codes/pages/icd10-code-edit/icd10-code-edit';
import { Icd10ViewComponent } from './features/codes/pages/icd10-view/icd10-view';
import { Icd8ViewComponent } from './features/codes/pages/icd8-view/icd8-view';
import { Icd9ViewComponent } from './features/codes/pages/icd9-view/icd9-view';

export const codesRoutes: Routes = [
  secureRoute({
    path: 'codes/icd10',
    component: Icd10ViewComponent,
    data: {
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: true,
          url: '/codes/icd10',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd10/:code',
    component: IcdCodeDetailsComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd10',
      breadcrumbs: [
        { id: 0, label: 'kody', isCurrent: false, url: '/codes/icd10' },
        { id: 1, label: 'szczegóły', isCurrent: true, url: '/codes/icd10/:code' },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd10/create',
    component: IcdCodeCreateComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd10',
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: false,
          url: '/codes/icd10',
        },
        {
          id: 1,
          label: 'tworzenie',
          isCurrent: true,
          url: '/codes/icd10/create',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd10/:codeId/edit',
    component: Icd10CodeEditComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd10',
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: false,
          url: '/codes/icd10',
        },
        {
          id: 1,
          label: 'edycja',
          isCurrent: true,
          url: '/codes/icd10/:codeId/edit',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd8',
    component: Icd8ViewComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: true,
          url: '/codes/icd8',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd8/create',
    component: IcdCodeCreateComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd8',
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: false,
          url: '/codes/icd8',
        },
        {
          id: 1,
          label: 'tworzenie',
          isCurrent: true,
          url: '/codes/icd8/create',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd8/:code',
    component: IcdCodeDetailsComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd8',
      breadcrumbs: [
        { id: 0, label: 'kody', isCurrent: false, url: '/codes/icd8' },
        { id: 1, label: 'szczegóły', isCurrent: true, url: '/codes/icd8/:code' },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd8/create',
    component: IcdCodeCreateComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd8',
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: false,
          url: '/codes/icd8',
        },
        {
          id: 1,
          label: 'tworzenie',
          isCurrent: true,
          url: '/codes/icd8/create',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd8/:codeId/edit',
    component: IcdCodeEditComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd8',
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: false,
          url: '/codes/icd8',
        },
        {
          id: 1,
          label: 'edycja',
          isCurrent: true,
          url: '/codes/icd8/:code/edit',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd9',
    component: Icd9ViewComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: true,
          url: '/codes/icd9',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd9/create',
    component: IcdCodeCreateComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd9',
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: false,
          url: '/codes/icd9',
        },
        {
          id: 1,
          label: 'tworzenie',
          isCurrent: true,
          url: '/codes/icd9/create',
        },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd9/:code',
    component: IcdCodeDetailsComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd9',
      breadcrumbs: [
        { id: 0, label: 'kody', isCurrent: false, url: '/codes/icd9' },
        { id: 1, label: 'szczegóły', isCurrent: true, url: '/codes/icd9/:code' },
      ],
    },
  }),
  secureRoute({
    path: 'codes/icd9/:codeId/edit',
    component: IcdCodeEditComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      codeType: 'Icd9',
      breadcrumbs: [
        {
          id: 0,
          label: 'kody',
          isCurrent: false,
          url: '/codes/icd9',
        },
        {
          id: 1,
          label: 'edycja',
          isCurrent: true,
          url: '/codes/icd9/:codeId/edit',
        },
      ],
    },
  }),
];
